import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../features/auth/useAuth';
import { readNextPath } from '../lib/nextPath';
import { FullPageStatus } from './FullPageStatus';

/**
 * Keeps signed-in users off the sign-in and sign-up screens.
 * /reset-password is deliberately not wrapped in this: the recovery link
 * creates a session before the user sets a new password.
 *
 * A session arriving here goes to the screen's `?next=` path, not always
 * home: that is how an email-confirm link that lands on `/login?next=...`
 * with a fresh session carries on to an invite.
 */
export function PublicOnlyRoute() {
  const { session, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <FullPageStatus message="Checking your session" />;
  }

  return session ? <Navigate to={readNextPath(location)} replace /> : <Outlet />;
}
